import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

export default function EmailVerificationPage() {
  const [params] = useSearchParams();
  const [message, setMessage] = useState("Verifying your email...");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setMessage("This verification link is invalid.");
      return;
    }
    api.post("/auth/email-verification", { token })
      .then(() => setMessage("Your email is verified. You can now sign in securely."))
      .catch(() => setMessage("This verification link is invalid or expired."));
  }, [params]);

  return <main className="auth-form-side" data-testid="email-verification-page"><div className="auth-card"><h2>Email verification</h2><p data-testid="email-verification-message">{message}</p><Link className="primary-button auth-submit" to="/login" data-testid="email-verification-login-link">Continue to sign in</Link></div></main>;
}